import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "bankNumberCustomFormat"
})
export class BankNumberCustomFormatPipe implements PipeTransform {
	transform(field: any): string {
		let bankNumberType = "";

		if (field?.key === "ACCOUNT_NUMBER") {
			bankNumberType = "Account";
		} else if (field?.key === "CARD_NUMBER") {
			bankNumberType = "Card";
		} else if (field?.key === "IBAN") {
			bankNumberType = "Iban";
		}

		let finalResult = "";

		if (field?.value) {
			finalResult = `${bankNumberType} ***${field?.value?.slice(-4)}`;
		}
		return finalResult;
	}
}
